/** Domains often used for throwaway / disposable signups (subset; extend as needed). */
const DISPOSABLE_DOMAINS = new Set(
  [
    'mailinator.com',
    'guerrillamail.com',
    '10minutemail.com',
    'tempmail.com',
    'throwaway.email',
    'yopmail.com',
    'trashmail.com',
    'fakeinbox.com',
    'getnada.com',
    'maildrop.cc',
    'sharklasers.com',
    'grr.la',
    'dispostable.com',
    'mailnesia.com',
    'temp-mail.org',
    'emailondeck.com',
    'burnermail.io',
    'trashmail.net',
    'spam4.me',
    'mailcatch.com',
    'mintemail.com',
    'mohmal.com',
    'tmpmail.org',
    'tempr.email',
    'discard.email',
    'mailnull.com',
    'spamgourmet.com',
    'mytrashmail.com',
    'mailinator.net',
    'guerrillamailblock.com',
  ].map((d) => d.toLowerCase())
);

const BASIC_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export type SyntaxCheckResult = 'ok' | 'invalid_format' | 'disposable_domain';

export function extractEmailDomain(email: string): string | null {
  const trimmed = email.trim().toLowerCase();
  const at = trimmed.lastIndexOf('@');
  if (at < 1 || at === trimmed.length - 1) return null;
  return trimmed.slice(at + 1);
}

/**
 * Stricter than a single regex: length limits, no consecutive dots, plausible domain.
 */
export function checkContactEmailSyntax(email: string): SyntaxCheckResult {
  const raw = email.trim();
  if (!raw) return 'invalid_format';

  const lower = raw.toLowerCase();
  if (lower.includes(' ') || lower.includes('..')) return 'invalid_format';
  if (raw.length > 254) return 'invalid_format';

  if (!BASIC_EMAIL.test(lower)) return 'invalid_format';

  const domain = extractEmailDomain(lower);
  if (!domain || domain.length > 253) return 'invalid_format';

  const local = lower.slice(0, lower.indexOf('@'));
  if (local.length > 64 || local.length === 0) return 'invalid_format';

  if (DISPOSABLE_DOMAINS.has(domain)) return 'disposable_domain';

  return 'ok';
}
